import React, { Component } from 'react'
import config from '../../config';
import { connect } from 'react-redux';
import { NavBar, BreadCumb, TimeOut, SettingsAdmin, RequestAmbassadors, NotificationReferrals } from '../../components';
import { DISPATCH_ID } from '../../libs/utils/Const';

class AdminReferredSystem extends Component {

    constructor(props) {
        super(props)
        this.state = {
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
            , view: 2
        };
    }

    UpdateStateField = (key, value) => {
        this.setState({
            [key]: value
        })
    }

    render() {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user, view } = this.state;
        return (
            <div>
                <NavBar props={this.props} logoCounter={true} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'Admin. referidos'} url1={'#'} />

                <div style={{ marginLeft: "5rem", marginRight: "1rem", marginBottom: "5rem" }}>
                    <div className="row h3 mb-3"> Administrador de referidos</div>
                    <div className="row">
                        <div className='w-100'>
                            <nav>
                                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                    {/* <a
                                        className={`nav-item nav-link font-weight-bold text-secondary ${view === 1 ? 'active' : ''}`}
                                        id="nav-profile-tab-Requests"
                                        data-toggle="tab"
                                        href="#RequestsAdmin"
                                        role="tab"
                                        onClick={() => this.UpdateStateField('view', 1)}
                                        aria-controls="RequestsAdmin" >
                                        Solicitudes
                                    </a> */}
                                    <a
                                        className={`nav-item nav-link font-weight-bold text-secondary ${view === 2 ? 'active' : ''}`}
                                        id="nav-profile-tab-settingsAdmin"
                                        data-toggle="tab"
                                        href="#settingsAdmin"
                                        role="tab"
                                        onClick={() => this.UpdateStateField('view', 2)}
                                        aria-controls="settingsAdmin" >
                                        Configuraciones
                                    </a>
                                    <a
                                        className={`nav-item nav-link font-weight-bold text-secondary ${view === 3 ? 'active' : ''}`}
                                        id="nav-profile-tab-notificationsAdmin"
                                        data-toggle="tab"
                                        href="#notificationsAdmin"
                                        role="tab"
                                        onClick={() => this.UpdateStateField('view', 3)}
                                        aria-controls="notificationsAdmin" >
                                        Notificaciones
                                    </a>
                                </div>
                            </nav>

                            <div className="tab-content border border-top-0 rounded-bottom p-3">
                                <div id="RequestsAdmin" className={`tab-pane px-3 ${view === 1 ? 'active' : ''}`} role="tabpanel" aria-labelledby="nav-profile-tab-List" >
                                    {view === 1 &&
                                        <RequestAmbassadors
                                            showAlert={showAlert}
                                            enableSpinner={enableSpinner}
                                        />
                                    }
                                </div>

                                <div id="dataListPendingOrders" className={`tab-pane px-3 ${view === 2 ? 'active' : ''}`} role="tabpanel" aria-labelledby="nav-profile-tab-List" >
                                    {view === 2 &&
                                        <SettingsAdmin
                                            showAlert={showAlert}
                                            enableSpinner={enableSpinner}
                                        />
                                    }
                                </div>

                                <div id="notificationsAdmin" className={`tab-pane px-3 ${view === 3 ? 'active' : ''}`} role="tabpanel" aria-labelledby="nav-profile-tab-List" >
                                    {view === 3 &&
                                        <NotificationReferrals
                                            showAlert={showAlert}
                                            enableSpinner={enableSpinner}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminReferredSystem);
